import { FC, useState, useRef } from 'react'

import useTranslate from '../../../i18n/useTranslate'

import UploadImage from '../../../control/uploadImage/uploadImage'
import usePreferenceProfile from '../../../services/um/usePreferenceProfile'
import useAuthenStore from '../../../stores/authen/authenStore'
import useAuthenAction from '../../../stores/authen/authenAction'
import Dialog, { DialogType } from '../../../control/dialog/dialog'

interface UploadProfileProps {
    getNewProfile: () => void
}
const UploadProfile: FC<UploadProfileProps> = ({ getNewProfile }) => {
    const t = useTranslate()
    const authenAction = useAuthenAction()
    const authenStore = useAuthenStore()
    const { postImage } = usePreferenceProfile()
    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()

    const onUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0]

        if (file?.type.includes('image')) {
            if (file && file.size > 31457280) {
                //10 mb to byte (1 mb = 1048576 byte)
                setConfigDialog({
                    title: `${t.get('ALERT.TITLE.WARNING')}`,
                    content: `${t.get('ALERT.CONTENT.UPLOAD_NOT_EXCEED_30_MB')}`,
                    type: 'alert-message',
                    onAfterClose: () => {
                        //@ts-ignore
                        document.getElementById('imgUpload').value = ''
                    },
                })
            } else {
                setConfigDialog({
                    title: `${t.get('UM.PROFILE.UPLOAD_PROFILE_HEADER')}`,
                    content: `${t.get('UM.PROFILE.UPLOAD_PROFILE_CONFIRM')}`,
                    type: 'alert-confirm',
                    onClickConfirm: () => onSave(event),
                })
            }
        } else {
            // ต้องไม่สามารถอัพไฟล์อื่นที่ไม่ใช่รูปภาพได้
            setConfigDialog({
                title: `${t.get('ALERT.TITLE.WARNING')}`,
                content: `${t.get('ALERT.CONTENT.UPLOAD_IMG_FILE_ONLY')}`,
                type: 'alert-message',
                onAfterClose: () => {
                    //@ts-ignore
                    document.getElementById('imgUpload').value = ''
                },
            })
        }
        dialogTwoRef.current?.openDialog()
    }

    const onSave = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0]
        const formDataImage = new FormData()
        if (file) {
            formDataImage.append('userID', String(authenStore.profile.userId))
            formDataImage.append('files', file)
            const upload = await postImage(formDataImage)

            if (upload) {
                setConfigDialog({
                    title: `${t.get('UM.PROFILE.UPLOAD_PROFILE_HEADER')}`,
                    content: `${t.get('UM.PROFILE.UPLOAD_PROFILE_SUCCESS')}`,
                    type: 'alert-message',
                })
                dialogTwoRef.current?.openDialog()
                await getNewProfile()
            }
        }
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    return (
        <>
            <UploadImage name="imgUpload" label={t.get('UM.PROFILE.IMG_UPLOAD')} onChange={onUpload} />
            <Dialog onRef={onRefDialogTwo} {...configDialog} />
        </>
    )
}

export default UploadProfile
